import { 
  SET_AREAS_LOADING, 
  SET_AREAS_DATA
} from "./types";
import { api } from "../App";

export const getAreas = (region_id) => async (dispatch) => {
  try {
    dispatch({ type: SET_AREAS_LOADING, payload: true });
    const params = region_id ? { params: { region_id } } : {};
    const { data } = await api.get('/monitoring_lms_cons/areas', params);
    dispatch({ type: SET_AREAS_DATA, payload: data.areas || data });
  } catch (ERR) {
    console.error('Ошибка при загрузке населенных пунктов:', ERR);
  } finally {
    dispatch({ type: SET_AREAS_LOADING, payload: false });
  }
}

